import config from "../../config.json";
const BASE_AUTH_API = config.BASE_AUTH_API;

export const fetchStoresAPI = async (token, sId) => {
  let responseData;
  try {
    const params = new URLSearchParams();
    sId.forEach((id) => params.append("ids", id));

    const url = `${BASE_AUTH_API}operation/stores?${params.toString()}`;
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.stores;
    } else {
      return;
    }
  } catch (error) {
    return;
  }
};

export const fetchCampaignsAPI = async (token, app) => {
  let responseData;
  try {
    const url = `${BASE_AUTH_API}operation/campaigns?app=${app}`;
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.data;
    } else {
      return;
    }
  } catch (error) {
    return;
  }
};

export const fetchMenusAPI = async (token) => {
  let responseData;
  try {
    const url = `${BASE_AUTH_API}operation/menu`;
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData.data;
    } else {
      return;
    }
  } catch (error) {
    return;
  }
};

export const fetchMonthlyAPI = async (token, data) => {
  let responseData;
  try {
    const url = `${BASE_AUTH_API}operation/monthly`;
    await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData;
    } else {
      return;
    }
  } catch (error) {
    return;
  }
};

export const fetchDailyAPI = async (token, data) => {
  let responseData;
  try {
    const url = `${BASE_AUTH_API}operation/daily`;
    await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData;
    } else {
      return;
    }
  } catch (error) {
    return;
  }
};

export const fetchCompenstationAPI = async (token, data) => {
  let responseData;
  try {
    const url = `${BASE_AUTH_API}operation/compensation`;
    await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));
    if (responseData.success) {
      return responseData;
    } else {
      return;
    }
  } catch (error) {
    return;
  }
};

export const fetchSaledItemsAPI = async (token, data) => {
  let responseData;
  try {
    const url = `${BASE_AUTH_API}operation/saled-items`;
    await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData.data;
    } else {
      return;
    }
  } catch (error) {
    return;
  }
};
